import { IGetEventsDetailsResponse } from "../models";
import { convertTimeToMinutes } from "./date-time.service";
import * as _ from 'lodash';
import moment from 'moment';

interface INewGetEventsDetailsResponse extends IGetEventsDetailsResponse {
  isFavorite: boolean
}

const selectedTrackType = (type: number, selected?: string[], countryCode?: string): boolean => {

  let result: boolean = false;
  let trackTypeIs: string = '';

  switch(type) {
    // Quarterhorse included based on frontend repo
    case 1:
      trackTypeIs = 'Thoroughbred';
      break;

    case 2:
      trackTypeIs = 'Greyhound';
      break;

    case 3:
      trackTypeIs = 'Quarterhorse';
      break;

    case 4:
      trackTypeIs = 'Harness';
      break;
  }

  // !type &&
  if (
    (countryCode === null || countryCode !== 'US') &&
    !selected?.includes('International')
  ) {
    return result;
  }

  if (
    countryCode !== null &&
    countryCode !== 'US' &&
    selected?.includes('International')
  ) {
    trackTypeIs = 'International';
  }

  if (selected?.includes(trackTypeIs)) {
    result = true;
  }

  return result;
}

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const sortEvents = (
  allEvents: IGetEventsDetailsResponse[],
  sortBy?: string,
  trackType?: string[],
  listFavorites?: Set<string>
): any => {
  const today = moment().utc();

  let newListEvent: INewGetEventsDetailsResponse[] = [];

  // identify event if favorite
  allEvents = _.map(allEvents, (event) =>
    event = {
      ...event,
      isFavorite: listFavorites?.has(event.id as string) || undefined
    } as IGetEventsDetailsResponse
  );

  allEvents = _.filter(allEvents, event => {
    const races = _.get(event, 'ToteResponse.EventDetail.Races');
    return !_.isNil(races) && !_.isEmpty(races);
  });

  if (sortBy === 'MTP') {
    const newListEventFn = (isFavorite?: boolean) =>
      _.concat(
        _.orderBy(
          // open - MTP - Today
          // event?.ToteResponse?.EventDetail?.currentRace?.RaceStatus === 0
          _.filter(allEvents, (event: INewGetEventsDetailsResponse) => {
            const eventStatusIsOpen
             = event?.ToteResponse?.EventDetail?.currentRace?.RaceStatus === 0;
            // (
            //   event?.ToteResponse?.EventDetail?.EventStatus === 'Open' as string &&
            //   event?.ToteResponse?.EventDetail?.currentRace?.RaceStatus === 0
            // );
            const races = event?.ToteResponse?.EventDetail?.Races;
            // Check if all RaceStatus === 3
            const allRacesAreFinished = Array.isArray(races) && races.length > 0
              ? races.every((race: any) => race?.RaceStatus === 3)
              : false;

            return (
              (eventStatusIsOpen && !allRacesAreFinished)
              && moment(event?.ToteResponse?.EventDetail?.currentRace?.PostTime+'Z')
                .isSame(today, 'day')
              && convertTimeToMinutes(
                event?.ToteResponse?.EventDetail?.currentRace?.PostTime+'Z'
              ) <= 60
              && selectedTrackType(
                event?.ToteResponse?.EventDetail?.TrackType, trackType, event?.CountryCode
              ) === true
              && event?.isFavorite === isFavorite
            );
          }),
          ['ToteResponse.EventDetail.currentRace.PostTime'],
          ['asc']
        ),
        _.orderBy(
          // open - Time - Today
          // event?.ToteResponse?.EventDetail?.currentRace?.RaceStatus === 0
          _.filter(allEvents, (event: INewGetEventsDetailsResponse) => {
            const eventStatusIsOpen
             = event?.ToteResponse?.EventDetail?.currentRace?.RaceStatus === 0;
            // (
            //   event?.ToteResponse?.EventDetail?.EventStatus === 'Open' as string &&
            //   event?.ToteResponse?.EventDetail?.currentRace?.RaceStatus === 0
            // );
            const races = event?.ToteResponse?.EventDetail?.Races;
            // Check if all RaceStatus === 3
            const allRacesAreFinished = Array.isArray(races) && races.length > 0
              ? races.every((race: any) => race?.RaceStatus === 3)
              : false;

            return (
              (eventStatusIsOpen && !allRacesAreFinished)
              && moment(event?.ToteResponse?.EventDetail?.currentRace?.PostTime+'Z')
                .isSame(today, 'day')
              && convertTimeToMinutes(
                event?.ToteResponse?.EventDetail?.currentRace?.PostTime+'Z'
              ) > 60
              && selectedTrackType(
                event?.ToteResponse?.EventDetail?.TrackType, trackType, event?.CountryCode
              ) === true
              && event?.isFavorite === isFavorite
            );
          }),
          ['ToteResponse.EventDetail.currentRace.PostTime'],
          ['asc']
        ),
        _.orderBy(
          // open - Time - Tomorrow
          // event?.ToteResponse?.EventDetail?.currentRace?.RaceStatus === 0
          _.filter(allEvents, (event: INewGetEventsDetailsResponse) => {
            const eventStatusIsOpen
             = event?.ToteResponse?.EventDetail?.currentRace?.RaceStatus === 0;
            // (
            //   event?.ToteResponse?.EventDetail?.EventStatus === 'Open' as string &&
            //   event?.ToteResponse?.EventDetail?.currentRace?.RaceStatus === 0
            // );
            const races = event?.ToteResponse?.EventDetail?.Races;
            // Check if all RaceStatus === 3
            const allRacesAreFinished = Array.isArray(races) && races.length > 0
              ? races.every((race: any) => race?.RaceStatus === 3)
              : false;

            return (
              (eventStatusIsOpen && !allRacesAreFinished)
              && !moment(event?.ToteResponse?.EventDetail?.currentRace?.PostTime+'Z')
                .isSame(today, 'day')
              && selectedTrackType(
                event?.ToteResponse?.EventDetail?.TrackType, trackType, event?.CountryCode
              ) === true
              && event?.isFavorite === isFavorite
            );
          }),
          ['ToteResponse.EventDetail.currentRace.PostTime'],
          ['asc']
        ),
        _.orderBy(
          // closed
          // event?.ToteResponse?.EventDetail?.currentRace?.RaceStatus === 1
          _.filter(allEvents, (event: INewGetEventsDetailsResponse) => {
            const eventStatusIsClosed
             = event?.ToteResponse?.EventDetail?.currentRace?.RaceStatus === 1;
            // (
            //   event?.ToteResponse?.EventDetail?.EventStatus === 'Closed' as string ||
            //   (
            //     event?.ToteResponse?.EventDetail?.currentRace?.RaceStatus !== 4 &&
            //     event?.ToteResponse?.EventDetail?.currentRace?.RaceStatus !== 3 &&
            //     event?.ToteResponse?.EventDetail?.currentRace?.RaceStatus !== 2 &&
            //     event?.ToteResponse?.EventDetail?.currentRace?.RaceStatus === 1
            //   )
            // );
            const races = event?.ToteResponse?.EventDetail?.Races;
            // Check if all RaceStatus === 3
            const allRacesAreFinished = Array.isArray(races) && races.length > 0
              ? races.every((race: any) => race?.RaceStatus === 3)
              : false;

            return (
              (eventStatusIsClosed && !allRacesAreFinished)
              && selectedTrackType(
                event?.ToteResponse?.EventDetail?.TrackType, trackType, event?.CountryCode
              ) === true
              && event?.isFavorite === isFavorite
            );
          }),
          ['ToteResponse.EventDetail.currentRace.PostTime'],
          ['asc']
        ),
        _.orderBy(
          // post
          // event?.ToteResponse?.EventDetail?.currentRace?.RaceStatus === 2
          _.filter(allEvents, (event: INewGetEventsDetailsResponse) => {
            const eventStatusIsPost
             = event?.ToteResponse?.EventDetail?.currentRace?.RaceStatus === 2;
            // (
            //   event?.ToteResponse?.EventDetail?.EventStatus === 'Post' as string ||
            //   (
            //     event?.ToteResponse?.EventDetail?.currentRace?.RaceStatus !== 4 &&
            //     event?.ToteResponse?.EventDetail?.currentRace?.RaceStatus !== 3 &&
            //     event?.ToteResponse?.EventDetail?.currentRace?.RaceStatus !== 1 &&
            //     event?.ToteResponse?.EventDetail?.currentRace?.RaceStatus === 2
            //   )
            // );
            const races = event?.ToteResponse?.EventDetail?.Races;
            // Check if all RaceStatus === 3
            const allRacesAreFinished = Array.isArray(races) && races.length > 0
              ? races.every((race: any) => race?.RaceStatus === 3)
              : false;

            return (
              (eventStatusIsPost && !allRacesAreFinished)
              && selectedTrackType(
                event?.ToteResponse?.EventDetail?.TrackType, trackType, event?.CountryCode
              ) === true
              && event?.isFavorite === isFavorite
            );
          }),
          ['ToteResponse.EventDetail.currentRace.PostTime'],
          ['asc']
        ),
        _.orderBy(
          // finished - EventStatus
          // final - event?.ToteResponse?.EventDetail?.currentRace?.RaceStatus === 3
          _.filter(allEvents, (event: INewGetEventsDetailsResponse) => {
            const eventStatusIsFinished = (
              event?.ToteResponse?.EventDetail?.EventStatus === 'Finished' as string
            );
            const races = event?.ToteResponse?.EventDetail?.Races;
            // Check if all RaceStatus === 3
            const allRacesAreFinished =
            Array.isArray(races) && races.length > 0
              ? (() => {
                  const emptyPoolsCount = races.filter(
                    (race: any) => (
                      !Array.isArray(race?.Pools) ||
                      race.Pools.length === 0
                    ) &&
                      race?.RaceStatus !== 3
                  ).length;

                  const validRaceCount = races.length - emptyPoolsCount;
                  if (validRaceCount <= 0) {
                    return false;
                  }

                  const finishedValidRaces = races.filter(
                    (race: any) =>
                      Array.isArray(race?.Pools) &&
                      // race.Pools.length > 0 &&
                      race?.RaceStatus === 3
                  ).length;
                  return finishedValidRaces === validRaceCount;
                })()
              : false;

            // const allRacesAreFinished = Array.isArray(races) && races.length > 0
            //   ? races.every((race: any) => race?.RaceStatus === 3)
            //   : false;

            return (
              (eventStatusIsFinished || allRacesAreFinished)
              && selectedTrackType(
                event?.ToteResponse?.EventDetail?.TrackType, trackType, event?.CountryCode
              ) === true
              && event?.isFavorite === isFavorite
            );
          }),
          ['ToteResponse.EventDetail.currentRace.PostTime'],
          ['asc']
        ),
        _.orderBy(
          // cancelled
          // event?.ToteResponse?.EventDetail?.currentRace?.RaceStatus === 4
          _.filter(allEvents, (event: INewGetEventsDetailsResponse) => {
            const eventStatusIsCancelled
             = event?.ToteResponse?.EventDetail?.currentRace?.RaceStatus === 4;
            // (
            //   event?.ToteResponse?.EventDetail?.EventStatus === 'Cancelled' as string ||
            //   (
            //     event?.ToteResponse?.EventDetail?.currentRace?.RaceStatus !== 3 &&
            //     event?.ToteResponse?.EventDetail?.currentRace?.RaceStatus !== 2 &&
            //     event?.ToteResponse?.EventDetail?.currentRace?.RaceStatus !== 1 &&
            //     event?.ToteResponse?.EventDetail?.currentRace?.RaceStatus === 4
            //   )
            // );
            const races = event?.ToteResponse?.EventDetail?.Races;
            // Check if all RaceStatus === 3
            const allRacesAreFinished = Array.isArray(races) && races.length > 0
              ? races.every((race: any) => race?.RaceStatus === 3)
              : false;

            return (
              (eventStatusIsCancelled && !allRacesAreFinished)
              && selectedTrackType(
                event?.ToteResponse?.EventDetail?.TrackType, trackType, event?.CountryCode
              ) === true
              && event?.isFavorite === isFavorite
            );
          }),
          ['ToteResponse.EventDetail.currentRace.PostTime'],
          ['asc']
        )
      ) as INewGetEventsDetailsResponse[];

    // separate by favorite
    newListEvent = _.concat(
      ...newListEventFn(true),
      ...newListEventFn(undefined)
    );
  }
  else if (sortBy === 'Name') {
    const newListEventFn = (isFavorite?: boolean) =>
      _.concat(
        _.orderBy(
          // others
          _.filter(allEvents, (event: INewGetEventsDetailsResponse) => {
            const eventStatusIsNotFinished = (
              event?.ToteResponse?.EventDetail?.EventStatus !== 'Finished' as string
            );
            const races = event?.ToteResponse?.EventDetail?.Races;
            // Check if all RaceStatus === 3
            const allRacesAreFinished = Array.isArray(races) && races.length > 0
              ? races.every((race: any) => race?.RaceStatus === 3)
              : false;

            return (
              (eventStatusIsNotFinished && !allRacesAreFinished)
              && selectedTrackType(
                event?.ToteResponse?.EventDetail?.TrackType, trackType, event?.CountryCode
              ) === true
              && event?.isFavorite === isFavorite
            );
          }),
          [
            (event: INewGetEventsDetailsResponse) =>
              (
                event.CountryCode != null
                && event.CountryCode !== 'US'
                && event.CountryCode !== 'CA'
                && event.CountryCode !== ''
                  ? event.CountryCode
                  : ''
              )
              + event.ToteResponse.EventDetail.EventName
          ],
          ['asc']
        ),
        _.orderBy(
          // finished - EventStatus
          // event?.ToteResponse?.EventDetail?.currentRace?.RaceStatus === 3
          _.filter(allEvents, (event: INewGetEventsDetailsResponse) => {
            const eventStatusIsFinished = (
              event?.ToteResponse?.EventDetail?.EventStatus === 'Finished' as string
            );
            const races = event?.ToteResponse?.EventDetail?.Races;
            // Check if all RaceStatus === 3
            const allRacesAreFinished = Array.isArray(races) && races.length > 0
              ? races.every((race: any) => race?.RaceStatus === 3)
              : false;

            return (
              (eventStatusIsFinished || allRacesAreFinished)
              && selectedTrackType(
                event?.ToteResponse?.EventDetail?.TrackType, trackType, event?.CountryCode
              ) === true
              && event?.isFavorite === isFavorite
            );
          }),
          [
            (event: INewGetEventsDetailsResponse) =>
              (
                event.CountryCode != null
                && event.CountryCode !== 'US'
                && event.CountryCode !== 'CA'
                && event.CountryCode !== ''
                  ? event.CountryCode
                  : ''
              )
              + event.ToteResponse.EventDetail.EventName
          ],
          ['asc']
        )
      ) as INewGetEventsDetailsResponse[];

    // separate by favorite
    newListEvent = _.concat(
      ...newListEventFn(true),
      ...newListEventFn(undefined)
    );
  }

  return newListEvent;
}
